module.exports = __webpack_public_path__ + "img/bangladesh.7b44a00f.svg";